import React, { useState } from "react";
import { Link } from "react-router-dom";
import GoogleAuth from "./GoogleAuth";
import axios from "axios";

const GoogleMeet = () => {
  const [meetLink, setMeetLink] = useState("");
  const [accessToken, setAccessToken] = useState("");

  const createGoogleMeet = async () => {
    try {
      const response = await axios.post(
        "https://www.googleapis.com/calendar/v3/calendars/primary/events",
        {
          summary: "Google Meet Meeting",
          start: { dateTime: new Date().toISOString() },
          end: { dateTime: new Date(new Date().getTime() + 60 * 60000).toISOString() },
          conferenceData: { createRequest: { requestId: "unique-request-id", conferenceSolutionKey: { type: "hangoutsMeet" } } },
        },
        { headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } }
      );

      const meetLink = response.data.conferenceData.entryPoints[0].uri;
      setMeetLink(meetLink);
    } catch (error) {
      console.error("Error creating Google Meet:", error);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="mb-1">Google Meet</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="#">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Application</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Google Meet
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="text-start mb-4">
          <GoogleAuth onLoginSuccess={(token) => setAccessToken(token)} />

          <button className="btn btn-info me-3" onClick={createGoogleMeet} disabled={!accessToken}>
            Generate Google Meet Link
          </button>
        </div>

        <div className="card bg-white">
          <div className="card-body">

            {meetLink ? (
              <div className="mt-3">
                <p>Google Meet Link: <a href={meetLink} target="_blank">{meetLink}</a></p>
                <div style={{ backgroundColor: "#f0f0f0", padding: "10px", textAlign: "center" }}>
                  <iframe
                    src={meetLink}
                    width="800"
                    height="600"
                    allow="camera; microphone; fullscreen"
                    style={{ border: "none", backgroundColor: "#E5E4E2" }}
                  ></iframe>
                </div>
              </div>
            ) : (
              <div className="mt-3">
                <p>Google Meet View.</p>
                <div style={{ backgroundColor: "#f0f0f0", padding: "10px", textAlign: "center" }}>
                  <iframe
                    src="https://meet.google.com/landing" // A placeholder URL for the Google Meet page
                    width="800"
                    height="600"
                    style={{ border: "none", backgroundColor: "#E5E4E2" }}
                  ></iframe>
                </div>
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default GoogleMeet;